import { formatPhoneNumber } from '@sidecar-utilities/phoneNumbers/formatPhoneNumber'

/**
 * Returns the phone number for member care based on the insurance product and
 * member's group.
 *
 * @param {string} insuranceProduct - One of the Sidecar Health products
 * @param {string} dedicatedPhoneNumber - Employer group's dedicated phone
 *   number
 * @returns {string}
 */
export const getMemberCareNumberByProduct = (
  insuranceProduct,
  dedicatedPhoneNumber = '',
) => {
  // If the member's group has a dedicated number (ex: Koch), show that number
  if (dedicatedPhoneNumber && dedicatedPhoneNumber !== '0000000000') {
    // add dashes because the BE only returns numbers
    return formatPhoneNumber(dedicatedPhoneNumber)
  }

  // If the group doesn't have a dedicated number, return a product-specific phone number
  switch (insuranceProduct) {
    case 'ACA':
      return '855-262-8461'

    case 'ASO':
      return '855-460-2494'

    case 'GFI':
      return '855-282-0822'

    case 'FIXED_INDEMNITY':
      return '408-430-5500'

    default:
      return '877-653-6440'
  }
}
